import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

import type { DeleteProductVariantRequestDto } from "../../dtos/delete-product-variant-request-dto";
import { ProductQueryKeys } from "../../generators/product-query-keys";
import { ProductService } from "../../services/product-service";

type UseDeleteProductVariantMutation = {
  options?: UseMutationOptions<
    { success: boolean },
    unknown,
    DeleteProductVariantRequestDto
  >;
};

export const useDeleteProductVariantMutation = ({
  options
}: UseDeleteProductVariantMutation = {}) => {
  const queryClient = useQueryClient();
  const { slug } = useParams({ from: "/products/list/$slug/edit" });

  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.deleteProductVariant({ payload });
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ProductQueryKeys.getProductDetail({
          slug
        }).queryKey
      });
      options?.onSuccess?.(...args);
    },
    ...options
  });
};
